import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";

export function Layout() {
  return (
    <div className="layout">
      <Sidebar />
      <main className="main">
        {/* Mientras se descarga el código de una página, el sidebar sigue visible. */}
        <Suspense fallback={<div className="loading">Cargando…</div>}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
